import { Card, CardBody, CardHeader, EmptyState } from '../../components/ui'
import { UsersGroupIcon } from '../../components/icons'

/* The join-request queue is closed.
 *
 * People no longer apply to a cooperative and a cooperative no longer
 * recruits: the platform administrator assigns every account to its
 * organisation (see api_create_allocation_request and
 * api_approve_allocation_request, both of which now refuse). The route is
 * kept so an old bookmark or a link in a past notification explains itself
 * rather than 404-ing. */
export default function AllocationRequests() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Join requests</h1>
          <p className="page-head__sub">How people are added to your cooperative.</p>
        </div>
      </div>

      <Card>
        <CardHeader title="Assigned by the administrator" />
        <CardBody>
          <EmptyState
            icon={<UsersGroupIcon size={22} />}
            title="There is nothing to review here"
            body={
              'Members are no longer added by request or invitation. The platform '
              + 'administrator assigns each account to its cooperative, so there is no '
              + 'queue to approve. To have someone added to your team, contact the '
              + 'administrator with their details — they will appear on your Team page '
              + 'once assigned.'
            }
          />
        </CardBody>
      </Card>
    </>
  )
}
